var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-main", [
    _c("div", {
      staticStyle: {
        width: "100vw",
        height: "20px",
        "background-color": "#224474",
        clear: "both",
      },
    }),
    _vm._v(" "),
    _c("div", {
      staticStyle: {
        width: "100vw",
        height: "10vh",
        "background-color": "#ffffff",
        clear: "both",
        "background-image":
          "linear-gradient(to bottom, #b4cff3 0%, #fcfeff 100%)",
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container1",
        staticStyle: { "align-content": "center", "justify-content": "center" },
      },
      [
        _c("img", {
          staticClass: "bg-image",
          attrs: {
            src: "/public/background",
            alt: "Background description",
            loading: "lazy",
          },
          on: {
            error: function ($event) {
              $event.target.src = "content/images/wheet_img.jpg"
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "content",
            staticStyle: {
              "align-content": "center",
              "justify-content": "center",
            },
          },
          [_c("router-view")],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticStyle: {
        width: "100vw",
        height: "10vh",
        "background-color": "#ffffff",
        clear: "both",
        "background-image": "linear-gradient(to top, #b4cff3 0%, #fcfeff 100%)",
      },
    }),
    _vm._v(" "),
    _c("div", {
      staticStyle: {
        width: "100vw",
        height: "20px",
        "background-color": "#224474",
        clear: "both",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }